import { render } from "./PasswordReset.vue?vue&type=template&id=6892d9bf&bindings={\"next\":\"props\",\"logout\":\"props\",\"errors\":\"data\",\"isLoading\":\"data\",\"email\":\"data\",\"success\":\"data\",\"login\":\"options\"}"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"
script.render = render

export default script